module.exports = __webpack_public_path__ + "static/media/Group76-768.fb416bcc.webp";